module.exports = __webpack_public_path__ + "static/media/camacari-bh.a36efa2a.jpg";